import React, { useEffect, useState } from "react";
import Airtable from "airtable";
import { Table, Button, Form } from "react-bootstrap";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import logo from "./logo-sigal_3.png";

// const MAX_DISCOUNT_PERCENT = 25;

let base = new Airtable({
	apiKey:
		"patBXQgJPv4W41ktc.c7c4725c447b5fbef08fcd945de907f7ff20eb53ee6213c0f546fc811def4547",
}).base("appZ1xuAo89gyeDRW");

function SmallSizes() {
	const [data, setData] = useState([]);
	// const [error, setError] = useState("");
	//const [vendors, setVendors] = useState([]);
	const [clients, setClients] = useState([]);
	const [selectedClient, setSelectedClient] = useState("");
	//const [selectedVendor, setSelectedVendor] = useState("");
	const [rows, setRows] = useState({
		בוגרים: [],
		ילדים: [],
		נעליים: [],
	});
	//const [url, setUrl] = useState("");
	const [newClient, setNewClient] = useState(false);
	const [graphicsType, setGraphicsType] = useState("");
	const [commentsField, setCommentsField] = useState("");
	const [taxPercent, setTaxPercent] = useState(0.18);

	const [rowsToDelete, setRowsToDelete] = useState([]);

	const [orderDone, setOrderDone] = useState({
		done: false,
		orderId: "",
		updateUrl: "",
		approveOrderUrl: "",
	});

	const [loadOrderData, setLoadOrderData] = useState({});

	//Component did mount/Update
	useEffect(() => {
		loadItems();
		loadVendors();
		loadClients();
	}, []);

	useEffect(() => {
		if (orderDone.done) {
			getApproveOrderUrl(orderDone.orderId);
		}
		// eslint-disable-next-line
	}, [orderDone.done]);

	const loadVendors = () => {
		let vendorsArray = [];
		base("סוכנים")
			.select({
				view: "הכל",
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						vendorsArray.push(record);
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					//setVendors([...vendorsArray]);
				}
			);
	};

	const loadClients = () => {
		let clientsArr = [];
		base("לקוחות")
			.select({
				view: "Grid view",
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						clientsArr.push(record);
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					setClients([...clientsArr]);
				}
			);
	};

	const loadOrder = () => {
		if (!loadOrderData.orderId || loadOrderData.orderId === "") {
			alert("אנא מלאו מספר הזמנה");
			return;
		}
		if (!loadOrderData.password || loadOrderData.password === "") {
			alert("אנא מלאו סיסמת סוכן");
			return;
		}

		base("הזמנות")
			.select({
				view: "כללי",
				filterByFormula: `AND({מס הזמנה} = '${loadOrderData.orderId}', {סיסמת סוכן} = '${loadOrderData.password}') `,
			})
			.firstPage(function (err, records) {
				if (err) {
					console.error(err);
					return;
				}
				if (records.length === 0) {
					alert("לא נמצאה הזמנה מתאימה.");
					return;
				}

				let returnedId = records[0].getId();
				let returnedOrderId = records[0].fields["מס הזמנה"];
				let returnedUpdateUrl = records[0].fields["iframeUpdateOrderForm"];
				let newClientField = records[0].fields["לקוח חדש"];
				let graphicTypeField = records[0].fields["סוג גרפיקת לוגו"];
				let commentsFieldData = records[0].fields["הערות להזמנה"];
				let taxPercentData = records[0].fields["taxPercent"];

				let approveWarehouse = records[0].fields["מאושר מחסן"];
				if (approveWarehouse === true) {
					alert("לא ניתן לערוך הזמנה זו (ההזמנה כבר אושרה במחסן)");
					return;
				}

				// setSelectedVendor(records[0].fields["סוכנים"][0]);
				setSelectedClient(records[0].fields["לקוח"][0]);
				setNewClient(newClientField);
				console.log(newClientField, graphicTypeField, commentsFieldData);
				setGraphicsType(graphicTypeField);
				setCommentsField(commentsFieldData);
				setTaxPercent(taxPercentData);
				setLoadOrderData({
					...loadOrderData,
					loadedOrderId: records[0].fields["מס הזמנה"],
					loadedRecId: returnedId,
					updateUrl: returnedUpdateUrl,
					checkApproveText: records[0].fields["checkApproveText"],
				});
				getOrderRows(returnedOrderId);
			});
	};

	const getApproveOrderUrl = (orderId) => {
		console.log("getApproveOrderUrl");
		base("הזמנות")
			.select({
				view: "כללי",
				filterByFormula: `{מס הזמנה} = '${orderId}'`,
			})
			.firstPage(function (err, records) {
				console.log(records, err);
				if (err) {
					console.error(err);
					return;
				}
				if (records.length === 0) {
					return;
				}

				let approveOrderUrl = records[0].fields["checkApproveText"];
				let newClientField = records[0].fields["לקוח חדש"];
				let graphicsTypeField = records[0].fields["סוג גרפיקת לוגו"];
				let commentsFieldData = records[0].fields["הערות להזמנה"];
				if (!approveOrderUrl) approveOrderUrl = "";

				setOrderDone({ ...orderDone, approveOrderUrl: approveOrderUrl });
				setNewClient(newClientField);
				setGraphicsType(graphicsTypeField);
				setCommentsField(commentsFieldData);
			});
	};

	const getOrderRows = (returnedId) => {
		let array = [];
		let objParsed = { ילדים: [], בוגרים: [], נעליים: [], הדפסים: [] };

		base("פריטי הזמנות")
			.select({
				view: "API",
				filterByFormula: `{הזמנה} = '${returnedId}'`,
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						const type = record.fields["type"];
						const rawType = record.fields["rawType"];
						array.push(record);
						objParsed[rawType].push({
							recId: record.getId(),
							id: record.fields["פריט"][0],
							comments: record.fields["הערות"],
							price: record.fields["מחיר סוכן למוצר"],
							sizes: {
								s: record.fields["S/39/4"],
								m: record.fields["M/40/6"],
								l: record.fields["L/41/8"],
								xl: record.fields["XL/42/10"],
								"2xl": record.fields["2XL/43/12"],
								"3xl": record.fields["3XL/44/14"],
								"4xl": record.fields["4XL/45/16"],
								"5xl": record.fields["5XL/46/18"],
								"s-36": record.fields["36"],
								"s-36-5": record.fields["36-5"],
								"s-37": record.fields["37"],
								"s-37-5": record.fields["37-5"],
								"s-38": record.fields["38"],
								"s-38-5": record.fields["38-5"],
								"s-39-5": record.fields["39-5"],
								"s-40-5": record.fields["40-5"],
								"s-41-5": record.fields["41-5"],
								"s-42-5": record.fields["42-5"],
								"s-43-5": record.fields["43-5"],
								"s-44-5": record.fields["44-5"],
								"s-45-5": record.fields["45-5"],
								"s-46-5": record.fields["46-5"],
								"s-47": record.fields["47"],
								"s-47-5": record.fields["47-5"],
								"s-48": record.fields["48"],

								oneSize: record.fields["One Size"],
							},
							colorId: record.fields["צבע"],
							checkboxData: record.fields["תפירה?"],
							isRikma: record.fields["רקמה?"],
							isPrinting: record.fields["הדפסה?"],
							type: type,
							rawType: rawType,
						});
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					setRows(objParsed);
				}
			);
	};

	const loadItems = () => {
		let array = [];

		base("פריטים")
			.select({
				view: "הכל",
			})
			.eachPage(
				function page(records, fetchNextPage) {
					records.forEach(function (record) {
						array.push(record);
					});
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}

					setData([...array]);
				}
			);
	};

	const getClientData = () => {
		if (!selectedClient || selectedClient === "") return {};

		let record = clients.filter((item) => selectedClient === item.id);
		if (record) {
			return record[0].fields;
		}
		return {};
	};

	const getProductPrice = (idx, type) => {
		if (
			!rows[type] ||
			!rows[type][idx] ||
			!rows[type][idx].id ||
			rows[type][idx].id === ""
		)
			return 0;

		let itemId = rows[type][idx].id;
		let record = data.filter((item) => itemId === item.id);

		if (record) {
			return record[0].fields.price;
		}
		return 0;
	};

	// const getProductMaxPrice = (basePrice) => {
	// 	return basePrice - (basePrice * MAX_DISCOUNT_PERCENT) / 100;
	// };

	const ColorSelector = ({ itemId }) => {
		let options = [];
		if (itemId) {
			let record = data.filter((item) => itemId === item.id);
			if (record && record[0].fields.Colors) {
				options = record[0].fields.Colors;
			}
		}

		return options.map((item, index) => {
			return (
				<option key={"color" + index} value={item}>
					{item}
				</option>
			);
		});
	};

	const sizeChanged = (e, idx, type) => {
		let size = e.target.getAttribute("data-size");

		let newRowsType = [...rows[type]];
		if (newRowsType[idx].sizes == null) newRowsType[idx].sizes = {};
		newRowsType[idx].sizes[size] = e.target.value;

		const newRows = { ...rows };
		newRows[type] = newRowsType;
		setRows(newRows);
	};

	const updateRows = async () => {
		let checkApproveText = "";
		try {
			let record = await base("הזמנות").update([
				{
					id: loadOrderData.loadedRecId,
					fields: {
						"סוג גרפיקת לוגו": graphicsType,
						"הערות להזמנה": commentsField,
						"הזמנה תוקנה": true,
						"אישור מנהל": false,
						"אושר/נדחה מנהל": null,
						"אישור גרפיקה": false,
						"אישור גרפיקה לקוח": false,
						"אישור משרד": false,
						"נשלח ווצאפ אישור ללקוח": 0
					},
				},
			]);
			checkApproveText = record[0].fields["checkApproveText"];
		} catch (err) {
			console.error(err);
			return;
		}

		if (rowsToDelete.length > 0)
			base("פריטי הזמנות").destroy(
				rowsToDelete,
				function (err, deletedRecords) {
					if (err) {
						console.error(err);
						return;
					}
					console.log("Deleted", deletedRecords.length, "records");
				}
			);

		setRowsToDelete([]);

		var rowsToUpdate = [];

		rowsToUpdate = getAllRows().map((row) => {
			return {
				id: row.recId,
				fields: {
					פריט: [row.id],
					הערות: row.comments,
					"תפירה?": row.checkboxData,
					"הדפסה?": row.isPrinting,
					"רקמה?": row.isRikma,
					צבע: row.colorId,
					"S/39/4": parseInt(row.sizes["s"]),
					"M/40/6": parseInt(row.sizes["m"]),
					"L/41/8": parseInt(row.sizes["l"]),
					"XL/42/10": parseInt(row.sizes["xl"]),
					"2XL/43/12": parseInt(row.sizes["2xl"]),
					"3XL/44/14": parseInt(row.sizes["3xl"]),
					"4XL/45/16": parseInt(row.sizes["4xl"]),
					"5XL/46/18": parseInt(row.sizes["5xl"]),
					"One Size": parseInt(row.sizes["oneSize"]),
					36: parseInt(row.sizes["s-36"]),
					"36-5": parseInt(row.sizes["s-36-5"]),
					37: parseInt(row.sizes["s-37"]),
					"37-5": parseInt(row.sizes["s-37-5"]),
					38: parseInt(row.sizes["s-38"]),
					"38-5": parseInt(row.sizes["s-38-5"]),
					"39-5": parseInt(row.sizes["s-39-5"]),
					"40-5": parseInt(row.sizes["s-40-5"]),
					"41-5": parseInt(row.sizes["s-41-5"]),
					"42-5": parseInt(row.sizes["s-42-5"]),
					"43-5": parseInt(row.sizes["s-43-5"]),
					"44-5": parseInt(row.sizes["s-44-5"]),
					"45-5": parseInt(row.sizes["s-45-5"]),
					"46-5": parseInt(row.sizes["s-46-5"]),
					47: parseInt(row.sizes["s-47"]),
					"47-5": parseInt(row.sizes["s-47-5"]),
					48: parseInt(row.sizes["s-48"]),
					"מחיר סוכן למוצר": parseFloat(row.price),
					rawType: row.type,
					הזמנה: [loadOrderData.loadedRecId],
				},
			};
		});

		const rowsToCreate = rowsToUpdate
			.filter((row) => !row.id)
			.map((row) => {
				return { fields: row.fields };
			});
		rowsToUpdate = rowsToUpdate.filter((row) => row.id);

		let size = 8;
		for (let i = 0; i < rowsToUpdate.length; i += size) {
			const tempRows = rowsToUpdate.slice(i, i + size);
			try {
				await base("פריטי הזמנות").update(tempRows);
			} catch (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
		}

		for (let i = 0; i < rowsToCreate.length; i += size) {
			const tempRows = rowsToCreate.slice(i, i + size);
			try {
				await base("פריטי הזמנות").create(tempRows);
			} catch (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
		}

		setOrderDone({
			done: true,
			orderId: loadOrderData.loadedOrderId,
			orderRecordId: loadOrderData.loadedRecId,
			updateUrl: loadOrderData.updateUrl,
			approveOrderUrl: checkApproveText,
		});

		// base("פריטי הזמנות").update(rowsToUpdate, function (err, records) {
		// 	if (err) {
		// 		console.error(err);
		// 		alert("חלה שגיאה אנא נסו שוב");
		// 		return;
		// 	}
		// });
	};

	const createOrder = async () => {
		// if (!selectedVendor || selectedVendor === "") {
		// 	alert("לא ניתן לבצע הזמנה ללא בחירת סוכן!");
		// 	return;
		// }

		if (!selectedClient || selectedClient === "") {
			alert("לא ניתן לבצע הזמנה ללא בחירת לקוח!");
			return;
		}
		const input = [
			{
				fields: {
					// סוכנים: [selectedVendor],
					לקוח: [selectedClient],
					// clientAproovalPdfLink: pdfUrl.url,
					"לקוח חדש": newClient,
					"סוג גרפיקת לוגו": graphicsType,
					"הערות להזמנה": commentsField,
				},
			},
		];

		base("הזמנות").create(input, function (err, records) {
			if (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
			let newOrderRecId = records[0].id;
			let newOrderId = records[0].fields["מס הזמנה"];
			let orderUpdateUrl = records[0].fields["iframeUpdateOrderForm"];
			let checkApproveText = records[0].fields["checkApproveText"];
			uploadRowsAirtable(
				newOrderRecId,
				newOrderId,
				orderUpdateUrl,
				checkApproveText
			);
		});
	};

	const uploadRowsAirtable = async (
		orderRecordId,
		orderId,
		updateUrl,
		checkApproveText
	) => {
		var rowsToUpload = [];

		rowsToUpload = getAllRows().map((row) => {
			return {
				fields: {
					פריט: [row.id],
					הערות: row.comments,
					"תפירה?": row.checkboxData,
					"הדפסה?": row.isPrinting,
					"רקמה?": row.isRikma,
					rawType: row.type,
					צבע: row.colorId,
					"S/39/4": parseInt(row.sizes["s"]),
					"M/40/6": parseInt(row.sizes["m"]),
					"L/41/8": parseInt(row.sizes["l"]),
					"XL/42/10": parseInt(row.sizes["xl"]),
					"2XL/43/12": parseInt(row.sizes["2xl"]),
					"3XL/44/14": parseInt(row.sizes["3xl"]),
					"4XL/45/16": parseInt(row.sizes["4xl"]),
					"5XL/46/18": parseInt(row.sizes["5xl"]),
					"One Size": parseInt(row.sizes["oneSize"]),
					36: parseInt(row.sizes["s-36"]),
					"36-5": parseInt(row.sizes["s-36-5"]),
					37: parseInt(row.sizes["s-37"]),
					"37-5": parseInt(row.sizes["s-37-5"]),
					38: parseInt(row.sizes["s-38"]),
					"38-5": parseInt(row.sizes["s-38-5"]),
					"39-5": parseInt(row.sizes["s-39-5"]),
					"40-5": parseInt(row.sizes["s-40-5"]),
					"41-5": parseInt(row.sizes["s-41-5"]),
					"42-5": parseInt(row.sizes["s-42-5"]),
					"43-5": parseInt(row.sizes["s-43-5"]),
					"44-5": parseInt(row.sizes["s-44-5"]),
					"45-5": parseInt(row.sizes["s-45-5"]),
					"46-5": parseInt(row.sizes["s-46-5"]),
					47: parseInt(row.sizes["s-47"]),
					"47-5": parseInt(row.sizes["s-47-5"]),
					48: parseInt(row.sizes["s-48"]),
					"מחיר סוכן למוצר": parseFloat(row.price),
					הזמנה: [orderRecordId],
				},
			};
		});
		console.log(rowsToUpload);

		const size = 8;
		for (let i = 0; i < rowsToUpload.length; i += size) {
			const tempRows = rowsToUpload.slice(i, i + size);
			try {
				await base("פריטי הזמנות").create(tempRows);
			} catch (err) {
				console.error(err);
				alert("חלה שגיאה אנא נסו שוב");
				return;
			}
		}

		setOrderDone({
			done: true,
			orderId: orderId,
			updateUrl: updateUrl,
			approveOrderUrl: checkApproveText,
			orderRecordId: orderRecordId,
		});

		// base("פריטי הזמנות").create(rowsToUpload, function (err, records) {
		// 	if (err) {
		// 		console.error(err);
		// 		alert("חלה שגיאה אנא נסו שוב");
		// 		return;
		// 	}

		// 	setOrderDone({
		// 		done: true,
		// 		orderId: orderId,
		// 		updateUrl: updateUrl,
		// 		approveOrderUrl: checkApproveText,
		// 		orderRecordId: orderRecordId,
		// 	});
		// });
	};

	const isImportedOrder = () => {
		return (
			loadOrderData.loadedRecId != null && loadOrderData.loadedRecId !== ""
		);
	};

	const countSizes = (sizes) => {
		if (!sizes || sizes.length === 0) return 0;

		let counter = Object.values(sizes).reduce((prev, current) => {
			let num2 = current ? parseInt(current) : 0;
			return prev + num2;
		}, 0);
		return counter ? counter : 0;
	};

	const getAllRows = () => {
		let allRows = [];
		for (let i = 0; i < Object.keys(rows).length; i++) {
			const key = Object.keys(rows)[i];
			const sortedRows = rows[key].map((row) => {
				row.type = key;
				return row;
			});
			allRows = allRows.concat(sortedRows);
		}
		return allRows;
	};

	const orderItemsCounter = () => {
		let count = 0;
		const allRows = getAllRows();
		for (let i = 0; i < allRows.length; i++) {
			let row = allRows[i];
			let rowCount = countSizes(row.sizes);
			count += rowCount;
		}
		return count;
	};

	const orderSum = () => {
		let sum = 0;
		//const allRows = getAllRows();
		for (let i = 0; i < rows.נעליים.length; i++) {
			let row = rows.נעליים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.ילדים.length; i++) {
			let row = rows.ילדים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.בוגרים.length; i++) {
			let row = rows.בוגרים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = row.price ?? getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}
		return sum;
	};

	const orderSumBeforeDiscount = () => {
		let sum = 0;
		for (let i = 0; i < rows.נעליים.length; i++) {
			let row = rows.נעליים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.ילדים.length; i++) {
			let row = rows.ילדים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}

		for (let i = 0; i < rows.בוגרים.length; i++) {
			let row = rows.בוגרים[i];
			let rowCount = countSizes(row.sizes);
			let itemPrice = getProductPrice(i, row.type);
			sum += rowCount * itemPrice;
		}
		return sum;
	};

	const getItemSelectOptions = (type) => {
		const withPrints = type === "ילדים" || type === "בוגרים";
		return [
			...data
				.filter(
					(item) =>
						type === "" ||
						item.fields.type === type ||
						(withPrints && item.fields.type === "הדפסים")
				)
				.map((item) => {
					return { value: item.id, label: item.fields.Name };
				}),
		];
	};

	const TableRow = ({
		idx,
		itemId = null,
		colorId = null,
		checkboxData = false,
		isPrinting = false,
		isRikma = false,
		sizes = {},
		comments = null,
		price = null,
		type = "",
	}) => {
		let itemOptions = getItemSelectOptions(type);
		let sizesCounter = countSizes(sizes);
		const onBlurRow = (e) => sizeChanged(e, idx, type);
		return (
			<tr>
				<td>
					<Button
						variant="danger"
						size="sm"
						onClick={(e) => {
							let newRowsType = [...rows[type]];

							if (isImportedOrder()) {
								setRowsToDelete([...rowsToDelete, newRowsType[idx].recId]);
							}

							newRowsType.splice(idx, 1);
							const newRows = { ...rows };
							newRows[type] = newRowsType;
							setRows(newRows);
						}}
					>
						X
					</Button>
				</td>

				<td>
					<div style={{ width: "200px", fontSize: "14px" }}>
						<Select
							value={itemOptions.filter(function (option) {
								return option.value === itemId;
							})}
							placeholder="בחר פריט..."
							menuPortalTarget={document.querySelector("body")}
							onChange={(value) => {
								let newRowsType = [...rows[type]];
								newRowsType[idx] = {
									id: value.value,
									checkboxData: newRowsType[idx].checkboxData,
									comments: newRowsType[idx].comments,
									sizes: newRowsType[idx].sizes,
									recId: newRowsType[idx].recId,
									type: type,
								};

								const newRows = { ...rows };
								newRows[type] = newRowsType;

								setRows(newRows);
							}}
							options={itemOptions}
						/>
					</div>

					{/* <select
						value={itemId ?? ""}
						onChange={(e) => {
							let newRows = [...rows];
							newRows[idx] = {
								id: e.target.value,
								checkboxData: newRows[idx].checkboxData,
								comments: newRows[idx].comments,
								sizes: newRows[idx].sizes,
								recId: newRows[idx].recId,
							};

							setRows(newRows);
						}}
					>
						<option value="">בחר פריט</option>
						{data.map((item, index) => {
							return (
								<option key={item.id} value={item.id}>
									{item.fields.Name}
								</option>
							);
						})}
					</select> */}
				</td>
				<td>
					<select
						value={colorId ?? ""}
						onChange={(e) => {
							let newRowsType = [...rows[type]];
							newRowsType[idx] = {
								...newRowsType[idx],
								colorId: e.target.value,
							};

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					>
						<option value="">בחר צבע</option>
						<ColorSelector itemId={itemId} />
					</select>
				</td>
				{type !== "נעליים" && (
					<td>
						<textarea
							defaultValue={comments}
							onBlur={(e) => {
								let newRowsType = [...rows[type]];
								newRowsType[idx].comments = e.target.value;

								const newRows = { ...rows };
								newRows[type] = newRowsType;

								setRows(newRows);
							}}
						/>
						<label>
							<input
								onClick={(e) => {
									let newRowsType = [...rows[type]];
									newRowsType[idx] = {
										...newRowsType[idx],
										isPrinting: e.target.checked,
									};

									const newRows = { ...rows };
									newRows[type] = newRowsType;

									setRows(newRows);
								}}
								defaultChecked={isPrinting ?? false}
								type="checkbox"
								style={{ margin: "0 8px" }}
							/>
							הדפסה?
						</label>
						<label>
							<input
								onClick={(e) => {
									let newRowsType = [...rows[type]];
									newRowsType[idx] = {
										...newRowsType[idx],
										isRikma: e.target.checked,
									};

									const newRows = { ...rows };
									newRows[type] = newRowsType;

									setRows(newRows);
								}}
								defaultChecked={isRikma ?? false}
								type="checkbox"
								style={{ margin: "0 8px" }}
							/>
							רקמה?
						</label>
					</td>
				)}
				{type === "נעליים" ? (
					<>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-36"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-36"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-36-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-36-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-37"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-37"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-37-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-37-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-38"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-38"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-38-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-38-5"
							/>
						</td>
					</>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input input-0"
						min="0"
						defaultValue={sizes["s"] ?? ""}
						onBlur={onBlurRow}
						data-size="s"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-39-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-39-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input input-1"
						min="0"
						defaultValue={sizes["m"] ?? ""}
						onBlur={onBlurRow}
						data-size="m"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-40-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-40-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["l"] ?? ""}
						onBlur={onBlurRow}
						data-size="l"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-41-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-41-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-42-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-42-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["2xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="2xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-43-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-43-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["3xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="3xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-44-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-44-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["4xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="4xl"
					/>
				</td>
				{type === "נעליים" ? (
					<td>
						<input
							type="number"
							className="size-input input-0"
							min="0"
							defaultValue={sizes["s-45-5"] ?? ""}
							onBlur={onBlurRow}
							data-size="s-45-5"
						/>
					</td>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["5xl"] ?? ""}
						onBlur={onBlurRow}
						data-size="5xl"
					/>
				</td>
				{type === "נעליים" ? (
					<>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-46-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-46-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-47"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-47"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-47-5"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-47-5"
							/>
						</td>
						<td>
							<input
								type="number"
								className="size-input input-0"
								min="0"
								defaultValue={sizes["s-48"] ?? ""}
								onBlur={onBlurRow}
								data-size="s-48"
							/>
						</td>
					</>
				) : (
					""
				)}
				<td>
					<input
						type="number"
						className="size-input"
						min="0"
						defaultValue={sizes["oneSize"] ?? ""}
						onBlur={onBlurRow}
						data-size="oneSize"
					/>
				</td>
				<td>{sizesCounter}</td>
				<td>
					<input
						type="number"
						className="size-input"
						// min={getProductMaxPrice(getProductPrice(idx)).toString() ?? "0"}
						defaultValue={price}
						step=".01"
						placeholder={getProductPrice(idx, type) + "₪" ?? ""}
						onBlur={(e) => {
							let newRowsType = [...rows[type]];
							console.log(e.target.value);
							newRowsType[idx].price = e.target.value;

							const newRows = { ...rows };
							newRows[type] = newRowsType;

							setRows(newRows);
						}}
					/>
				</td>
				<td>
					{(sizesCounter * (price ?? getProductPrice(idx, type))).toFixed(1)}
					&nbsp;₪
				</td>
			</tr>
		);
	};

	let clientData = getClientData();

	let itemsCounter = orderItemsCounter();

	let totalPrice = orderSum();
	let totalPriceBeforeDiscount = orderSumBeforeDiscount();
	let discountPercentage = (1 - totalPrice / totalPriceBeforeDiscount) * 100;

	let sortedClients = clients.map((client) => {
		return { value: client.id, label: client.fields["שם לקוח"] };
	});
	return (
		<div className="App" id="App">
			<div style={{ textAlign: "center" }}>
				<img height="100" alt="logo" src={logo} />
				<div style={{ color: "#804c9e", fontWeight: "bold" }}>
					תמנע 7 חולון 5881307 | טל' 03-5580668 | פקס 03-5591101
					<br />
					ח.פ 513830638 | www.sigal-ba.co.il
				</div>
				<br />
			</div>
			{orderDone.done ? (
				<div style={{ textAlign: "center" }}>
					<h3>
						{orderDone.approveOrderUrl.includes("מנהל")
							? orderDone.approveOrderUrl
							: isImportedOrder()
							? "ההזמנה עודכנה בהצלחה!"
							: "ההזמנה בוצעה בהצלחה!"}
					</h3>
					<h5>מספר הזמנה: {orderDone.orderId}</h5>
					<h6>אנא שמור את מספר ההזמנה כדי לערוך את ההזמנה!</h6>
					{/* <h6>
						קישור לאישור הזמנה לקוח:
						<br />
						<a
							href={`https://sigal-steel.vercel.app/orders/${orderDone.orderRecordId}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{ fontSize: "20px", fontWeight: "bold" }}
						>
							https://sigal-steel.vercel.app/orders/
							{orderDone.orderRecordId}
						</a>
					</h6> */}
					{/* <h6>
						{isImportedOrder()
							? "אם ברצונכם לערוך פרטים נוספים בהזמנה, ניתן לעשות זאת מהטופס למטה"
							: "כדי לסיים את ההזמנה, אנא השלימו כמה פרטים נוספים על ההזמנה בטופס למטה"}
					</h6> */}
					<iframe
						title="טופס הזמנה"
						className="airtable-embed"
						src={orderDone.updateUrl}
						frameBorder="0"
						width="100%"
						height="1650"
					></iframe>
					<br />
					<br />
					<Button
						variant="success"
						style={{ margin: "5px" }}
						onClick={() => {
							window.location.reload();
						}}
					>
						בצע הזמנה נוספת
					</Button>
				</div>
			) : (
				<div>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						{/* <label>
							<b>סוכן:</b> &nbsp;
							<select
								disabled={isImportedOrder() ? true : false}
								value={selectedVendor ?? ""}
								onChange={(e) => {
									setSelectedVendor(e.target.value);
								}}
							>
								<option value="">שם הסוכן</option>
								{vendors.map((item, index) => {
									return (
										<option key={item.id} value={item.id}>
											{item.fields["שם הסוכן"]}
										</option>
									);
								})}
							</select>
						</label> */}

						<label>
							<b>לקוח:</b> &nbsp;
							<Select
								style={{ display: "inline-block" }}
								value={sortedClients.filter(function (option) {
									return option.value === selectedClient;
								})}
								placeholder="בחר לקוח..."
								onChange={(value) => {
									setSelectedClient(value.value);
								}}
								options={sortedClients}
							/>
						</label>
						<div style={{ textAlign: "center" }}>
							עריכת הזמנה:
							<Form.Control
								onBlur={(e) => {
									setLoadOrderData({
										...loadOrderData,
										orderId: e.target.value,
									});
								}}
								size="sm"
								type="text"
								placeholder="מספר הזמנה"
							/>
							<Form.Control
								onBlur={(e) => {
									setLoadOrderData({
										...loadOrderData,
										password: e.target.value,
									});
								}}
								size="sm"
								type="text"
								placeholder="סיסמא"
							/>
							<Button
								size="sm"
								variant="secondary"
								style={{ margin: "5px" }}
								onClick={() => {
									loadOrder();
								}}
							>
								טען הזמנה
							</Button>
						</div>
					</div>

					<br />
					{isImportedOrder() ? (
						<h4 style={{ textAlign: "center" }}>
							עריכת הזמנה מס': {loadOrderData.loadedOrderId}
							<Button
								variant="danger"
								size="sm"
								style={{ margin: "5px" }}
								onClick={() => {
									window.location.reload();
								}}
							>
								ביטול עריכה
							</Button>
						</h4>
					) : (
						<></>
					)}
					<br />
					{selectedClient && selectedClient !== "" ? (
						<>
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									flexWrap: "wrap",
									gap: "25px",
									fontSize: "18px",
								}}
							>
								<div>
									<b>לכבוד: </b>
									{clientData["שם לקוח"]}
								</div>
								<div>
									<b>סוכן: </b>
									{clientData["שם סוכן"]}
								</div>
								<div>
									<b>כתובת: </b>
									{clientData["כתובת"]}
								</div>
								<div>
									<b>ח"פ\ע"מ: </b>
									{clientData["ח.פ"]}
								</div>
								<div>
									<b>איש קשר: </b>
									{clientData["איש קשר שם"]}
								</div>
								<div>
									<b>טלפון: </b>
									{clientData["איש קשר טלפון"]}
								</div>
								<div>
									<b>טלפון נוסף: </b>
									{clientData["טלפון נוסף"]}
								</div>
								<div>
									<b>אימייל: </b>
									{clientData["מייל"]}
								</div>
								<div>
									<b>תנאי תשלום: </b>
									{clientData["תנאי תשלום"]}
								</div>
							</div>
							<br></br>
						</>
					) : (
						" "
					)}

					<h4>
						בוגרים{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									בוגרים: [
										{ id: null, sizes: {}, type: "בוגרים" },
										...rows["בוגרים"],
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>צבע</th>
								<th>הדפסה/רקמה</th>
								<th>S</th>
								<th>M</th>
								<th>L</th>
								<th>XL</th>
								<th>2XL</th>
								<th>3XL</th>
								<th>4XL</th>
								<th>5XL</th>
								<th>ONE SIZE</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
							</tr>
						</thead>
						<tbody>
							{rows["בוגרים"].map((item, idx) => (
								<TableRow
									idx={idx}
									key={idx}
									itemId={item.id}
									colorId={item.colorId}
									checkboxData={item.checkboxData}
									isPrinting={item.isPrinting}
									isRikma={item.isRikma}
									sizes={item.sizes}
									comments={item.comments}
									price={item.price}
									type={"בוגרים"}
								/>
							))}
						</tbody>
					</Table>
					<hr />
					<h4>
						ילדים{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									ילדים: [
										...rows["ילדים"],
										{ id: null, sizes: {}, type: "ילדים" },
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>צבע</th>
								<th>הדפסה/רקמה</th>
								<th>4</th>
								<th>6</th>
								<th>8</th>
								<th>10</th>
								<th>12</th>
								<th>14</th>
								<th>16</th>
								<th>18</th>
								<th>ONE SIZE</th>
								<th>מחיר ליח'</th>
								<th>כמות</th>
								<th>מחיר כולל</th>
							</tr>
						</thead>
						<tbody>
							{rows["ילדים"].map((item, idx) => (
								<TableRow
									idx={idx}
									key={idx}
									itemId={item.id}
									colorId={item.colorId}
									checkboxData={item.checkboxData}
									isPrinting={item.isPrinting}
									isRikma={item.isRikma}
									sizes={item.sizes}
									comments={item.comments}
									price={item.price}
									type={"ילדים"}
								/>
							))}
						</tbody>
					</Table>
					<hr />
					<h4>
						נעליים{" "}
						<Button
							variant="secondary"
							size="sm"
							onClick={() => {
								setRows({
									...rows,
									נעליים: [
										...rows["נעליים"],
										{ id: null, sizes: {}, type: "נעליים" },
									],
								});
							}}
						>
							הוסף שורה
						</Button>
					</h4>
					<Table
						id="tables"
						size={"sm"}
						responsive
						bordered
						style={{ textAlign: "center" }}
					>
						<thead>
							<tr>
								<th>מחיקה</th>
								<th>סוג פריט</th>
								<th>צבע</th>
								<th>36</th>
								<th>36.5</th>
								<th>37</th>
								<th>37.5</th>
								<th>38</th>
								<th>38.5</th>
								<th>39</th>
								<th>39.5</th>
								<th>40</th>
								<th>40.5</th>
								<th>41</th>
								<th>41.5</th>
								<th>42</th>
								<th>42.5</th>
								<th>43</th>
								<th>43.5</th>
								<th>44</th>
								<th>44.5</th>
								<th>45</th>
								<th>45.5</th>
								<th>46</th>
								<th>46.5</th>
								<th>47</th>
								<th>47.5</th>
								<th>48</th>
								<th>ONE SIZE</th>
								<th>כמות</th>
								<th>מחיר ליח'</th>
								<th>מחיר כולל</th>
							</tr>
						</thead>
						<tbody>
							{rows["נעליים"].map((item, idx) => (
								<TableRow
									idx={idx}
									key={idx}
									itemId={item.id}
									colorId={item.colorId}
									checkboxData={item.checkboxData}
									isPrinting={item.isPrinting}
									isRikma={item.isRikma}
									sizes={item.sizes}
									comments={item.comments}
									price={item.price}
									type={"נעליים"}
								/>
							))}
						</tbody>
					</Table>
					<br />
					<div
						style={{
							display: "flex",
							justifyContent: "space-evenly",
							fontWeight: "bold",
						}}
					>
						<div>כמות פריטים: {itemsCounter}</div>
						{discountPercentage > 0 && (
							<div>הנחה: {discountPercentage.toFixed(0)}%</div>
						)}
						<div>סכום הזמנה: {totalPrice.toFixed(1)} ₪</div>
						<div>מע"מ: {(totalPrice * taxPercent).toFixed(1)} ₪</div>
						<div>
							סכום הזמנה (כולל מע"מ):{" "}
							{(totalPrice * (1 + taxPercent)).toFixed(1)} ₪
						</div>
					</div>
					<br />

					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "8px",
							flexDirection: "column",
						}}
					>
						<label htmlFor="newClientCB">
							<input
								id="newClientCB"
								onClick={() => setNewClient(!newClient)}
								defaultChecked={newClient}
								key={"newClient" + loadOrderData.loadedRecId}
								type="checkbox"
								disabled={isImportedOrder()}
								style={{ margin: "0 8px" }}
							/>
							לקוח חדש?
						</label>
						<label htmlFor="graphicsTypeSelect">
							סוג גרפיקת לוגו:
							<select
								onChange={(e) => setGraphicsType(e.target.value)}
								defaultValue={graphicsType}
								key={"graphicsType" + loadOrderData.loadedRecId}
								style={{ margin: "0 8px" }}
								id="graphicsTypeSelect"
							>
								<option value="">בחר</option>
								<option value="לוגו קיים">לוגו קיים</option>
								<option value="תיקון בלוגו">תיקון בלוגו</option>
								<option value="לוגו חדש">לוגו חדש</option>
								<option value="לוגו קיים לאשר לוגו">לוגו קיים לאשר לוגו</option>
								<option value="ללא גרפיקה">ללא גרפיקה</option>
							</select>
						</label>
						<label htmlFor="commentsField">
							הערות:
							<br />
							<textarea
								onChange={(e) => setCommentsField(e.target.value)}
								cols="50"
								rows="3"
								id="commentsField"
								defaultValue={commentsField}
								key={"comments" + loadOrderData.loadedRecId}
							></textarea>
						</label>
					</div>
					<br />
					<div style={{ textAlign: "center" }}>
						<Button
							variant="success"
							style={{ margin: "5px", marginRight: "10px" }}
							onClick={() => {
								if (isImportedOrder()) {
									updateRows();
								} else {
									createOrder();
								}
							}}
						>
							{isImportedOrder() ? "עדכן הזמנה" : "צור הזמנה"}
						</Button>
					</div>
				</div>
			)}

			{clientData && clientData["blockMessage"] && (
				<div
					style={{
						position: "fixed",
						top: "0",
						left: "0",
						width: "100%",
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						background: "white",
					}}
				>
					<img width="300px" alt="logo" src={logo} />
					<h2 style={{ color: "#804c9e", fontWeight: "bold" }}>
						{clientData["blockMessage"]}
					</h2>
				</div>
			)}
		</div>
	);
}

export default SmallSizes;
